export const titles = {
    billReferenceNumber: "Bill Reference No",
    branchCode: "Branch Code",
    branchName: "Branch Name",
    billDate: "Bill Date",
    expences: "Expenses",
    billNumber: "Bill Number",
    expenceParticular: "Expense Particular",
    penalityAmount: "Penalty Amount",
    activePurchaseOrder: "Active Purchase Order",
}

export const fields = {
    costCenter: {
        label: "Cost Center",
    },
    glCode: {
        label: "GL Code",
    },
    partnerName: {
        label: "Partner Name",
        placeholder: "Partner Name",
    },
    billNumber: {
        label: "Bill Number",
        placeholder: "Bill Number",
    },
    billDate: {
        label: "Bill Date",
        placeholder: "Date"
    },
    branch: {
        label: "Branch",
        placeholder: "Branch"
    },
    expectedPaymentDate: {
        label: "Expected Payment Date",
        placeholder: "Date"
    },
    billReferenceNumber: {
        label: "Bill Reference Number",
        placeholder: "Reference Number"
    },
    billRecieptDate: {
        label: "Bill Receipt Date",
        placeholder: "Date"
    },
    glCode: {
        label: "GL Code",
        placeholder: "GL Code"
    },
    downloadInvoice: {
        label: "Download Invoice",
    },
    remarks: {
        label: "Remarks",
        placeholder: "Remarks"
    },
    vehicleNumber: {
        label: "Vehicle Number",
        placeholder: "Vehicle Number"
    },
    poReferenceNumber: {
        label: "PO Reference Number",
        placeholder: "Reference Number"
    }
}

export const headers = {
    partnerBillNo: "Partner Bill No",
    billInvoicePdf: "Bill Invoice PDF",
    partnerBillDate: "Partner Bill Date",
    referenceNumber: "Reference No.",
    integratedReferenceNumber: "Integrated Reference No.",
    sapReferenceNumber: "SAP Reference No.",
    billReciptDate: "Bill Receipt Date",
    partnerName: "Partner Name",
    billAmount: "Bill Amount (Rs)",
    pendingAmount: "Pending Amount (Rs)",
    expectedPaymentDate: "Expected Payment Date",
    penalities: "Penalties (Rs)",
    remarks: "Remarks",
    glCode: "GL Code",
    branchName: "Branch Name",
    status: "Status",
    approvedOn : "Approved On",
    createdOn: "Created On",
    createdBy: "Created By",
    modifiedOn: "Modified On",
    modifiedBy: "Modified By",
    invoicePdf: "Invoice PDF",
    coverLetterPdf: "Cover Letter PDF",
    billPdfStatus: "Bill PDF Status",
    actions: "View/Edit/Delete",
}